import { showAlert } from '@/store/actions'

export const asyncMiddleware = state => next => action => {
  const { callback } = action
  if ( action.async && typeof action.async.then === 'function' ) {
    return action.async
      .then( ( { data } ) => {
        if ( !callback ) {
          return next( { payload: data, ...action } )
        }
        return Array.isArray( callback )
          ? callback.map( cb => next( cb( data ) ) )
          : next( callback( data ) )
      } )
      .catch( ( { message } ) => {
        showAlert( {
          hasCancel: true,
          message: message,
          title: 'ERROR'
        } )
      } )
  }
  return next( action )
}



// WEBPACK FOOTER //
// ./src/store/mniddlewares/async.middleware.js